import { Grid2 } from "@mui/material";
import React from "react";
//styles
import styles from "./ChangeDetails.module.scss";
import CustomInput from "../../../../../../../GlobalComponents/CustomInput/CustomInput";
import { isKeyDelete } from "../../../../../../../Utils/utils";
import "react-toastify/dist/ReactToastify.css";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

function NewChangeDetails({ values, handleChange, inputErrorVar }) {
  return (
    <>
      <Grid2 className={styles.NewChangeDetailsMainContainer}>
        <Grid2 className={styles.Avatar}>
          <Grid2 className={styles.flexBox}>
            <Grid2 className={styles.Icon}>
              <AccountCircleOutlinedIcon className={styles.IconColor} />
            </Grid2>
            <Grid2 className={styles.Header}> Basic details</Grid2>
          </Grid2>
        </Grid2>

        <Grid2 className={styles.InputFlexBox}>
          <CustomInput
            title="Full Name"
            placeholder="Enter Name"
            value={values.name}
            error={inputErrorVar?.name}
            errorMessage={"Name is required"}
            setValue={(value) => {
              handleChange("name", "length", value, 3);
            }}
          />
        </Grid2>
        <Grid2 className={styles.InputFlexBox}>
          <Grid2 className={styles.InputWidth}>
            <CustomInput
              title="Email"
              placeholder="Enter Email"
              value={values.email}
              setValue={(value) => {
                handleChange("email", "email", value);
              }}
              disabled={true}
            />
          </Grid2>
          <Grid2 className={styles.InputWidth}>
            <CustomInput
              title="Contact Number"
              placeholder={
                values.country === "USA" ? "(999) 999-9999" : "99999-99999"
              }
              required={true}
              frontEndorment={
                values.country === "USA"
                  ? "+1"
                  : values.country === "India"
                  ? "+91"
                  : null
              }
              frontEndormentWidthAdjustment={false}
              error={inputErrorVar?.phoneNumber}
              errorMessage={"Contact number is required"}
              value={values.phoneNumber}
              setValue={(value, _, event) => {
                let metaData = isKeyDelete(event.nativeEvent);
                value = value.replace(/\D/g, "");
                handleChange("phoneNumber", "phoneNumber", value, 10, metaData);
              }}
            />
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}

export default NewChangeDetails;
